const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const mediasUpload = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MEDIAS_UPLOAD_REQUEST":
      return { loading: true, error: false, data: [] };
    case "MEDIAS_UPLOAD_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "MEDIAS_UPLOAD_ERROR":
      return { loading: false, error: true, data: [] };
    default:
      return state;
  }
};

export default mediasUpload;
